import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EmiDataService } from 'app/emi-data.service';


@Injectable()
export class CalculatorPageResolver implements Resolve<any> {
  constructor(
    private emiDataService: EmiDataService
  ) { }
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return this.emiDataService.getProductData(route.params['calculator-slug']);
  }
}


// WEBPACK FOOTER //
// ./src/app/service/calculator.resolve.ts